import UEStatusMeter from '../UEStatusMeter';
import UEStatusBadge from '../UEStatusBadge';

const BADGE_MAP = {
    Bronze: 'bronze',
    Silver: 'silver',
    Gold: 'gold',
    Platinum: 'platinum'
};

const rank = null;

const Loading = props =>
    <div className={props.className}>
        <p className="flex-1 text-lg text-center loading">Loading...</p>
    </div>;

const Content = ( {ueStatus, className, rank, ...props} ) =>
    <div className={className}>
        <span className='hidden'>{rank = BADGE_MAP[ueStatus.currentRank] || null}</span>
        {rank != null ? <p class="text-lg eliteStatusText">You are currently a <span className={`text-${ueStatus.currentRank.toLowerCase()}`}>{ueStatus.currentRank}</span> Ultradent Elite member:</p> : <p class="text-lg eliteStatusText">You have not reached an <span className="elite-default-color">Ultradent Elite</span> status yet:</p>}
        <div className="flex justify-around w-full">
            <div className="text-center flex-1">
                <p className="font-bold my-2 text-body">Current Status</p>
                <UEStatusBadge {...props} {...ueStatus} />
                {rank != null ? <p class="text-sm text-brand my-2"><a href="/customer-service/ultradent-elite">See your benefits</a></p> : <p class="text-sm text-brand my-2"><a href="/customer-service/ultradent-elite">Learn more</a></p>}
            </div>
            <div className="text-center flex-1 whitespace-pre">
                <p className="font-bold my-2 text-body">{(new Date()).getFullYear()} Progress</p>
                <UEStatusMeter {...props} {...ueStatus} />
            </div>
        </div>
    </div>;

export default {
    Loading,
    Content
};
